import React from 'react';
import './Gifloader.css';

const Gifloader = ({ name }) => {
    return (
        <section className="container overflow-hidden">
            <div className="text-center">
                <img alt="" src="/assets/images/loader.gif" className='img-fluid' />
                <div>Do Not Exit Window, {name} Issuing on blockchain </div>
            </div>
        </section>
    );
};

export default Gifloader;